import { TTeam } from "~/types/team";
import { baseService } from "../base";
import { PaginationResponse, QueryParams } from "../type";


const serializeQueryParams = (params?: QueryParams): string => {
  if (!params) return "";

  const searchParams = new URLSearchParams();

  const serialize = (obj: any, prefix?: string) => {
    for (const key in obj) {
      if (obj[key] !== undefined && obj[key] !== null && obj[key] !== "") {
        const k = prefix ? `${prefix}[${key}]` : key;
        const v = obj[key];

        if (typeof v === "object" && !Array.isArray(v)) {
          serialize(v, k);
        } else {
          searchParams.append(k, v.toString());
        }
      }
    }
  };

  serialize(params);
  return searchParams.toString();
};


export const teamServices = {
  getTeams: async (params?: QueryParams) => {
    const queryString = serializeQueryParams(params);
    const url = queryString ? `/teams?${queryString}` : "/teams";

    const { data } = await baseService.get<PaginationResponse<TTeam>>(url);
    return data;
  },

  getTeamById: async (id: string) => {
    const { data } = await baseService.get<TTeam>(`/teams/${id}`);
    return data;
  },
  deleteTeam: async (id: string) => {
    const { data } = await baseService.delete(`/teams/${id}`);
    return data;
  },
};
